import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import Ratio from '~/components/Abstracts/Ratio'
import ShopifyRichText from '~/components/Abstracts/ShopifyRichText'
import VideoComponentForwarded from '~/components/Abstracts/Video'
import { ProductCardProps } from '~/components/Slices/ProductCard'
import Image from '~/components/UI/Image'
import Link from '~/components/UI/Link'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const IMAGE_SIZES = [{ ratio: 3 / 24 }]

function SearchLineItem({
  className,
  image,
  name,
  label,
  link,
  trackingGTMData,
  index,
}: ProductCardProps) {
  const nameStyle = useStyle({
    textPreset: GlobalTextPreset.Title12Haffer,
    color: GlobalThemeColors.Black,
  })

  const labelStyle = useStyle({
    textPreset: GlobalTextPreset.Label12_11Haffer,
    color: GlobalThemeColors.DoveGray,
  })

  return (
    <Link className={cx(css.SearchLineItem, className)} {...link}>
      {image && (
        <>
          {image?.image && (
            <Image
              className={css.image}
              fill={true}
              style={{ objectFit: 'contain' }}
              ratio={css.ratio}
              sizesFromBreakpoints={IMAGE_SIZES}
              priority={index < 6 ? true : false}
              {...image?.image}
            />
          )}
          {image?.video && (
            <Ratio ratio={css.ratio}>
              <VideoComponentForwarded
                {...image?.video}
                autoPlay
                muted
                loop
                className={cx(css.video)}
                playsInline
              />
            </Ratio>
          )}
        </>
      )}
      <div className={css.texts}>
        {name && <h3 className={cx(css.name, nameStyle)}>{name}</h3>}

        <ShopifyRichText className={cx(css.label, labelStyle)} render={label} />
      </div>
    </Link>
  )
}

SearchLineItem.defaultProps = {}

export default SearchLineItem
